import { prop, map, defaultTo, values } from 'ramda';
import axios from './request';

/**
 * @typedef ResponseRequest
 * @prop {string} ID
 * @prop {string} CODE
 * @prop {string} DETAIL_PAGE_URL
 */

/**
 * @typedef ResponseClient
 * @prop {string} ID
 * @prop {string} SECOND_NAME
 * @prop {string} NAME
 * @prop {string} LAST_NAME
 * @prop {string} PERSONAL_MOBILE
 * @prop {ResponseRequest[]} requests
 */

/**
 * @typedef ResponseCall
 * @prop {string} ID
 * @prop {ResponseClient} client
 */

/**
 *
 * @param {ResponseRequest} request
 * @returns
 */
const transformRequest = (request) => ({
	id: request.ID,
	number: request.CODE,
	url: request.DETAIL_PAGE_URL,
})

/**
 *
 * @param {ResponseClient} client
 */
const clientFullName = (client) => {
	let fullName = [];

	if (client.SECOND_NAME) fullName.push(client.SECOND_NAME);
	if (client.NAME) fullName.push(client.NAME);
	if (client.LAST_NAME) fullName.push(client.LAST_NAME);

	return fullName.join(' ');
}

/**
 *
 * @param {ResponseCall} call
 */
const transformCall = ({ ID, client }) => ({
	id: ID,
	clientId: client.ID,
	clientName: clientFullName(client),
	clientPhone: client.PERSONAL_MOBILE,
	requests: map(transformRequest, values(client.requests))
})

/**
 *
 * @param {import('axios').AxiosRequestConfig?} config
 * @returns
 */
export default function getServiceCalls(config) {
	return axios.get('/api/Uiscom/getCurrentCalls/', config)
		.then(({ data }) => data)
		.then(prop('data'))
		.then(defaultTo([]))
		.then(values)
		.then(map(transformCall));
}
